import { render } from "./OfferExpired.vue?vue&type=template&id=04ef8842&scoped=true"
import script from "./OfferExpired.vue?vue&type=script&lang=js"
export * from "./OfferExpired.vue?vue&type=script&lang=js"

import "./OfferExpired.vue?vue&type=style&index=0&id=04ef8842&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04ef8842"

export default script